<template>
  <div class="scene" id="scene-1">
    <MockMobile
      id="mobile-static"
      class="mobile-static ani"
      :class="{
        'fix-me': activeElements['mobile-static'] === 'fixed',
        'end': activeElements['mobile-static'] === 'end'
      }"
      :procent="mobilePercentOfJourney"
    />
    <div id="trigger-1" class="triggers"></div>
    <Play
      id="play-moving"
      class="play-moving ani"
      :class="{
        'fix-me': activeElements['play-moving'] === 'fixed',
        'end': activeElements['play-moving'] === 'end'
      }"
    />
    <div id="trigger-2" class="triggers"></div>
  </div>
</template>

<script>
import Play from '@/components/Play.vue'
import MockMobile from '@/components/MockMobile.vue'
import senseScroll from '@/utils/senseScroll.js'

export default {
  name: 'SceneOne',
  data () {
    return {
      page: {},
      inside: false,
      directives: [
        {
          id: 'mobile-static',
          start: 'scene-1',
          end: 'trigger-1'
        },
        {
          id: 'play-moving',
          start: 'scene-1',
          end: 'trigger-2'
        }
      ]
    }
  },
  props: {
    scrollPos: Number
  },
  computed: {
    activeElements () {
      let self = this
      return senseScroll(self.directives, self.scrollPos)
    },
    mobilePercentOfJourney () {
      let start = this.offset(this.directives[0].start)
      let end = this.offset(this.directives[0].end)
      return ((start.top - this.scrollPos) / (start.top - end.top)) * 100
    }
  },
  watch: {
  },
  methods: {
    offset (elId) {
      var el = document.getElementById(elId)
      if (!el) return 0
      var rect = el.getBoundingClientRect()
      var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop
      return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
    }
  },
  mounted () {
  },
  components: {
    Play,
    MockMobile
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  #scene-1 {
    height: 460vh;
    position: relative;
  }
  .ani {
    opacity: 1;
    transition: opacity 0.2s ease;
    &.fix-me, &.end {
      opacity: 1;
    }
  }
  .mobile-static {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0px;
  }
  .play-moving {
    position: absolute;
    width: 100%;
    top: 0px;
  }
  .mobile-static.end, #trigger-1 {
    position: absolute;
    width: 100%;
    top: 180vh;
  }
  .play-moving.end, .stop, #trigger-2 {
    position: absolute;
    width: 100%;
    top: 380vh;
  }
  .fix-me {
    top: 0px;
    position: fixed !important;
  }
  .triggers {
    position: absolute;
    height: 100vh;
    width: 100%;
  }
</style>
